import { IMapset } from "~/interfaces";
import { CONFIG } from "~/config";
import { IMapState } from "~/state/map/interfaces";
import { SATURATION_MAPSETS } from "~/util/constants";

function alwaysReturnMapset(mapset?: IMapset): IMapset {
	if (!mapset) {
		return CONFIG.mapsets[0];
	}

	return mapset;
}

export function getMapsetBySEO(seo: string): IMapset {
	return alwaysReturnMapset(CONFIG.mapsets.find(mapset => mapset.seo === seo));
}

export function getMapsetById(id: number): IMapset {
	return alwaysReturnMapset(CONFIG.mapsets.find(mapset => mapset.id === id));
}

export function getMapsetSeoById(id: number): string {
	return alwaysReturnMapset(CONFIG.mapsets.find(mapset => mapset.id === id)).seo;
}

export function isM3dAvailable(id: number): boolean {
	return [1, 2, 3, 7, 8, 9, 26, 47, 57, 70].indexOf(id) !== -1;
}

export function isSaturationMapset(state: IMapState): boolean {
	return SATURATION_MAPSETS.indexOf(state.mapset) > -1;
}
